import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axiosClient from 'api/axiosClient';
import { Row, Col } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { updateBreadCrumbNews, updateSelecteDetail, updateMenuResearch } from 'redux/actions/menu';
import { SETTING_IMAGE_URL } from 'utils/constants';
import '../Elements/ListReasearch/style.css';
import './ConferenceWorkshopList.css';

const getTargetDate = (eventItem) => {
    const { day, month, year, time_start } = eventItem;
    return new Date(`${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${time_start}`).getTime();
};

const EventCard = ({ item, isPast, intl }) => {
    const history = useHistory();
    const imageUrl = item.image ? `${SETTING_IMAGE_URL}/${item.image}` : require('assets/img/custom/slide/1.jpg').default;
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateStr = `${months[item.month - 1]} ${item.day}, ${item.year}`;

    const pathSplit = window.location.pathname.split('/');
    const lang = pathSplit[1];
    const isVietnamese = lang === 'vi';

    const handleClick = (e) => {
        e.preventDefault();
        const detailPath = isVietnamese
            ? `/vi/conference-workshop/${item.id}`
            : `/conference-workshop/${item.id}`;
        history.push(detailPath);
    };

    return (
        <div className={`cw-event-card ${isPast ? 'past-event' : ''}`}>
            <a href="#" onClick={handleClick}>
                <div className="cw-event-img-wrapper">
                    {!isPast && <div className="cw-tag-upcoming">{intl.formatMessage({ id: 'Upcoming', defaultMessage: 'Upcoming' })}</div>}
                    {isPast && <div className="cw-tag-past">{intl.formatMessage({ id: 'PastEvent', defaultMessage: 'Past Event' })}</div>}
                    <img src={imageUrl} alt={item.name} className="cw-event-img" />
                    <div className="cw-event-date-badge">
                        {dateStr}
                    </div>
                </div>
                <div className="cw-event-title-wrapper">
                    <h4 className="cw-event-title">{item.name}</h4>
                </div>
            </a>
        </div>
    );
};

const ConferenceWorkshopList = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const [events, setEvents] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');

    useEffect(() => {
        axiosClient.get(`/menuItem/1`).then((res) => {
            const menuResearch = res.data.find(item => item.title === 'Research');
            if (menuResearch) {
                dispatch(updateMenuResearch(menuResearch));
            }
        }).catch(err => console.error(err));

        dispatch(updateBreadCrumbNews([
            {
                title: "Research",
                path: "#"
            },
            {
                title: intl.formatMessage({ id: 'Conferences & Workshops', defaultMessage: 'Conferences & Workshops' }),
                path: ""
            }
        ]));
        dispatch(updateSelecteDetail({ id: 1234 }));

        const fetchYears = async () => {
            try {
                const response = await axiosClient.get(`/events/years?unit=Home`);
                if (response.data) {
                    setYears(response.data);
                }
            } catch (error) {
                console.error("Error fetching years:", error);
            }
        };
        fetchYears();
    }, [dispatch, intl]);
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const yearParam = selectedYear !== '' ? `&year=${selectedYear}` : '';
                const response = await axiosClient.get(`/events?unit=Home${yearParam}`);
                if (response.data && response.data.data) {
                    setEvents(response.data.data);
                } else {
                    setEvents([]);
                }
            } catch (error) {
                console.error("Error fetching events:", error);
                setEvents([]);
            }
        };
        fetchEvents();
    }, [selectedYear]);

    const now = new Date().getTime();

    const filteredEvents = events.filter(e => e.name.toLowerCase().includes(searchQuery.toLowerCase()));

    const upcomingEvents = filteredEvents.filter(e => getTargetDate(e) > now).sort((a, b) => getTargetDate(a) - getTargetDate(b));
    const pastEvents = filteredEvents.filter(e => getTargetDate(e) <= now).sort((a, b) => getTargetDate(b) - getTargetDate(a));

    return (
        <div className="cw-list-container main-app">
            <Row className="row_title_custom" style={{ marginBottom: '20px' }}>
                <Col md="12" className="pl-0">
                    <span className="research_title_custom">{intl.formatMessage({ id: 'Conferences & Workshops', defaultMessage: 'Conferences & Workshops' })}</span>
                </Col>
            </Row>

            <div className="cw-filter-section">
                <div className="cw-search-wrapper">
                    <i className="nc-icon nc-zoom-split"></i>
                    <input
                        type="text"
                        placeholder={intl.formatMessage({ id: 'Search...', defaultMessage: 'Search...' })}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="cw-search-input"
                    />
                </div>
                <div className="cw-year-filter-wrapper">
                    <select
                        className="cw-year-select"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                    >
                        <option value="">{intl.formatMessage({ id: 'AllYears', defaultMessage: 'All Years' })}</option>
                        {years.map((item, index) => (
                            <option key={index} value={item.year}>{item.year}</option>
                        ))}
                    </select>
                </div>
            </div>

            {filteredEvents.length === 0 ? (
                <div className="cw-no-data-container">
                    <p className="cw-no-data-text">{intl.formatMessage({ id: 'NoEventsFound', defaultMessage: 'No events found.' })}</p>
                </div>
            ) : (
                <>
                    {upcomingEvents.length > 0 && (
                        <div className="cw-section">
                            <h2 className="cw-section-title">{intl.formatMessage({ id: 'Upcoming', defaultMessage: 'Upcoming Events' })}</h2>
                            <div className="cw-grid">
                                {upcomingEvents.map((item, index) => (
                                    <EventCard key={`upcoming-${index}`} item={item} isPast={false} intl={intl} />
                                ))}
                            </div>
                        </div>
                    )}

                    {pastEvents.length > 0 && (
                        <div className="cw-section">
                            <h2 className="cw-section-title">{intl.formatMessage({ id: 'PastEvent', defaultMessage: 'Past Events' })}</h2>
                            <div className="cw-grid">
                                {pastEvents.map((item, index) => (
                                    <EventCard key={`past-${index}`} item={item} isPast={true} intl={intl} />
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ConferenceWorkshopList;
